module.exports = __webpack_public_path__ + "static/scale-model-of-barrett-triangle-in-newark-new-jersey-bff0e0666c1c580268ef4a271c81503e.png";